<template>
  <b-container id="dashboardInitialContainer" class="mt-5 mb-5">
    <b-row>
      <div v-if="user.xray_active" class="title">
        myfo conseil expert
      </div>
      <div v-else class="title">
        myfo conseil serenity
      </div>
    </b-row>
    <b-row>
      <div class="subtitle mt-4">Vous souhaitez découvrir une autre solution ? <span>Découvrez nos offres</span></div>
    </b-row>

    <b-row>
      <div class="portefeuillesCard mt-4">
        <div class="title">
          Vos portefeuilles connectés
        </div>
        <div v-if="platform_contract_portfolio[0]">
          <b-row v-for="(item, index) in platform_contract_portfolio" :key="index" class="rowCols mt-4">
            <b-col cols="4"> {{ item.platform_contract.contract.name }} - {{ item.platform_contract.platform.name }} </b-col>
            <b-col cols="4"> {{ formatEuros(item.sum_assets) }} € </b-col>
            <b-col cols="4">
              <div v-if="!item.has_optimised">
                <a :href="route_scanner_overview" class="last">
                  Passer au Rayon X
                </a>
              </div>
              <div v-else style="color:grey">Déjà optimisé</div>
            </b-col>
          </b-row>
          <div class="mt-4" style="text-align: center;">
            <a :href="route_scanner_dashboard_credentials"><b-button class="btnStart">Connecter un nouveau portefeuille</b-button></a>
          </div>
          <div class="mt-4">
            <div class="end">Vous souhaitez construire un nouveau portefeuille ? <a :href="route_scanner_first_portfolio_select_fund">Utilisez notre constructeur</a></div>
          </div>
        </div>
      </div>
    </b-row>
    <b-row class="mt-4">
      <div class="analyseCard">
        <div class="title">
          Analyser l'ensemble de mon portefeuille :
        </div>
        <b-row class="rowCols mt-4">
          <b-col cols="12" md="5">
            <div class="colContainer">
              <div class="colTitle">
                Vision Laser
              </div>
              <div class="content">
                <div class="title">
                  Allocation
                </div>
                <div v-for="(item, index) in aggregate_assetclasses" :key="index" class="divContent">
                  <div>{{ item.name }}</div>
                  <div class="number">{{ Number(item.value).toFixed(0) }}%</div>
                </div>
              </div>
              <div class="mt-4" style="text-align:center">
                <a :href="route_scanner_lookthrough_summary"><b-button class="colBtn">Vue globale</b-button></a>
              </div>
            </div>
          </b-col>
          <b-col cols="12" md="7">
            <div class="colContainer">
              <div class="colTitle">Rayon X</div>
              <div class="content">
                <div class="title">
                  Les diagnostics
                </div>
                <div class="divContent">
                  <div>Frais de plateforme</div>
                  <div class="number">{{ formatEuros(platform_total_fees) }}€ / an</div>
                </div>
                <div class="divContent">
                  <div>Frais de gestion</div>
                  <div class="number">{{ formatEuros(total_management_fees_overall) }} € / an</div>
                </div>
                <div class="divContent">
                  <div>Votre note ESG</div>
                  <div class="number">{{ Number(total_esg_score).toFixed(0) }} / 100</div>
                </div>
              </div>
              <div class="mt-4" style="text-align:center">
                <a :href="route_scanner_overview"><b-button class="colBtn triggerspinner">Passer au diagnostic</b-button></a>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div v-if="accessgranted"></div>
          <div v-else>
            <div class="row element-x-ray my-3" style="border: 1px solid rgba(255, 255, 255, .12);">
              <div class="col-md-10 my-auto px-3">
                <p class="fts-18 light-white-03" style="font-weight: 900;">La version premium : débloquez le potentiel d'optimisation du <span class="light-blue-01">Rayon X</span></p>
                <p class="h-emphasis fts-14">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                  </svg>
                  Débloquez le top 3 des positions les plus avantageuses de l'optimiseur de frais pour chacune de vos positions
                </p>
                <p class="h-emphasis fts-14">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                  </svg>
                  Accédez à la liste complète de la décomposition de vos positions via la fonction laser
                </p>
                <p class="h-emphasis fts-14">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                  </svg>
                  Passez vos ordres en toute simplicité grâce à l'assistant intelligent d'aide à l'achat et à la vente de positions
                </p>
                <p class="h-emphasis fts-14">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                  </svg>
                  Accédez à toutes les futures fonctionnalités du Rayon X gratuitement
                </p>
                <a class="fts-14 light-blue-01" :href="route_scanner_payment_portal" role="button">
                  Passer premium
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short ml-1" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </b-row>
      </div>
    </b-row>
  </b-container>
</template>
<script>
export default {
  props: [
    "platform_contract_portfolio",
    "route_scanner_overview",
    "route_scanner_dashboard_credentials",
     "route_scanner_first_portfolio_select_fund",
      "aggregate_assetclasses",
       "route_scanner_lookthrough_summary",
        "total_esg_score",
        "platform_total_fees",
        "total_management_fees_overall",
         "accessgranted",
          "route_scanner_payment_portal",
           "cheapest",
           "user",
            "total_savings",
             "total_savings_deposit"],
  mounted() {
  },
  methods: {
    formatEuros(number)
    {
      return this.$utils.numberWithSpaces(Number(number).toFixed(0));
    },
  }
};
</script>
<style lang="scss">
@import "../../../../sass/_variables.scss";
#dashboardInitialContainer {
  .row {
    justify-content: center;
  }
  .title {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
  }
  .subtitle {
    text-align: center;
    letter-spacing: 0px;
    font: normal normal normal $mf_ft_size_big_subtitle Dosis;
    opacity: 1;
    color: $mf_ft_color_white;
    span {
      text-align: center;
      letter-spacing: 0px;
      color: $purple_color;
    }
  }
  .portefeuillesCard {
    background: #242527 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    margin: auto;
    padding: 20px;
    width: 60%;
    .title {
      text-align: left;
      font: normal normal bold $mf_ft_size_title Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
      opacity: 1;
    }
    .rowCols {
      text-align: left;
      font: normal normal $mf_ft_size_text Segoe UI;
      color: $mf_ft_color_white;
      .last {
        text-align: left;
        font: normal normal bold $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: $purple_color;
        opacity: 1;
      }
    }
    .btnStart {
      background: $purple_color 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 41px;
      font: normal normal $mf_ft_size_text Segoe UI;
      opacity: 1;
      border: none;
      width: 60%;
      margin: auto;
    }
    .end {
      text-align: center;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      font: normal normal $mf_ft_size_text Segoe UI;
      opacity: 1;
      a {
        color: $purple_color;
      }
    }
  }
  .analyseCard {
    background: #242527 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    width: 80%;
    margin: 5px;
    padding: 20px;
    .title {
      text-align: left;
      font: normal normal bold $mf_ft_size_title Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
      opacity: 1;
    }
    .rowCols {
      .colContainer {
        background: #121212 0% 0% no-repeat padding-box;
        border-radius: 20px;
        opacity: 1;
        padding: 20px;
        margin: 5px;
        .colTitle {
          text-align: center;
          font: normal normal bold $mf_ft_size_text Segoe UI;
          letter-spacing: 0px;
          margin-bottom: 15px;
          color: $mf_ft_color_white;
          opacity: 1;
        }
        .content {
          background: #242527 0% 0% no-repeat padding-box;
          border-radius: 20px;
          opacity: 1;
          .title {
            padding: 10px;
            text-align: center;
            font: normal normal bold $mf_ft_size_text Segoe UI;
            letter-spacing: 0px;
            color: $purple_color;
            opacity: 1;
          }
          .divContent {
            padding: 10px;
            display: flex;
            justify-content: space-around;
            border-top: 2px solid #121212;
            color: $mf_ft_color_white;
            .number {
              color: $purple_color;
            }
          }
        }
        .colBtn {
          background: $purple_color 0% 0% no-repeat padding-box;
          box-shadow: 0px 3px 6px #00000029;
          border-radius: 41px;
          opacity: 1;
          border: none;
          width: 80%;
          a {
            color: $mf_ft_color_white;
          }
        }
      }
    }
  }
}
</style>
